import React from 'react';

import { Button, RefreshIcon, Text } from '@thefarmersfront/kitchen-mobile';

import styles from './OptionRefetchButton.module.scss';

type TypeOptionsRefetchButtonProps = {
  show: boolean;
  onRefetch?: () => void;
};

const OptionRefetchButton = ({
  show = false,
  onRefetch = () => undefined,
}: TypeOptionsRefetchButtonProps): React.JSX.Element =>
  show ? (
    <Button
      className={styles['option-refetch-button']}
      onClick={onRefetch}
      size="small"
      color="secondary"
      variant="outlined"
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
        <RefreshIcon size={16} />
        <Text size="medium" weight="semi-bold">
          정보 조회하기
        </Text>
      </div>
      <Text size="small" color="tertiary">
        정보를 불러오던 중 에러가 발생했습니다.
      </Text>
    </Button>
  ) : (
    <></>
  );

export default OptionRefetchButton;
